let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aPJu5")).then(() => parcelRequire('g5gkO'));